document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.vicio-header');
  const onScroll = () => header && header.classList.toggle('is-scrolled', window.scrollY > 12);
  onScroll();
  window.addEventListener('scroll', onScroll, { passive: true });

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (!reduceMotion) {
    document.documentElement.classList.add('vicio-motion-ready');
    const revealItems = [...document.querySelectorAll('[data-reveal]')];
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.13, rootMargin: '0px 0px -7% 0px' });

      revealItems.forEach((item, index) => {
        item.style.transitionDelay = Math.min((index % 4) * 70, 210) + 'ms';
        observer.observe(item);
      });
    } else {
      revealItems.forEach((item) => item.classList.add('is-revealed'));
    }
  } else {
    document.querySelectorAll('[data-reveal]').forEach((item) => item.classList.add('is-revealed'));
  }

  let toast = document.querySelector('.vicio-cart-toast');
  if (!toast) {
    toast = document.createElement('div');
    toast.className = 'vicio-cart-toast';
    toast.setAttribute('role', 'status');
    toast.setAttribute('aria-live', 'polite');
    toast.innerHTML = '<b>✓</b><span>Añadido · abriendo checkout</span>';
    document.body.appendChild(toast);
  }

  const showToast = () => {
    toast.classList.add('is-visible');
    window.setTimeout(() => toast.classList.remove('is-visible'), 1600);
  };

  document.querySelectorAll('form[data-vicio-buy]').forEach((form) => {
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const cartIcon = document.querySelector('a[href*="/cart"].vicio-iconlink');

      if (button) {
        button.disabled = true;
        button.dataset.originalText = button.textContent;
        button.textContent = 'AÑADIENDO…';
      }

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json' },
          body: new FormData(form)
        });
        if (!response.ok) throw new Error('cart');

        if (button) {
          button.classList.add('is-added');
          button.textContent = 'AÑADIDO ✓';
        }
        if (cartIcon) {
          cartIcon.classList.remove('is-cart-pulse');
          void cartIcon.offsetWidth;
          cartIcon.classList.add('is-cart-pulse');
        }
        showToast();

        window.setTimeout(() => {
          if (button) button.textContent = 'ABRIENDO CHECKOUT…';
          window.location.href = '/checkout';
        }, 480);
      } catch (error) {
        if (button) {
          button.disabled = false;
          button.textContent = button.dataset.originalText || 'COMPRAR AHORA';
        }
        form.submit();
      }
    });
  });
});